import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FieldFilling } from '../../types/interfaces';

const initialState: FieldFilling[] = []; // Directly assign an empty array as initial state

const fieldFillingControllSlice = createSlice({
  name: 'fieldFillingControll',
  initialState,
  reducers: {
    updateFieldFillingControll: (
      state,
      action: PayloadAction<FieldFilling[]>
    ) => {
      return action.payload; // Replace the entire state (array) with the new payload
    },
    resetFieldFillingControll: () => {
      return []; // Reset state to an empty array
    }
  }
});

export const { updateFieldFillingControll, resetFieldFillingControll } =
  fieldFillingControllSlice.actions;
export default fieldFillingControllSlice.reducer;
